import axiosInstance from './axiosInstance';

const getAllTournaments = async () => {
	try {
		const response = await axiosInstance.get('/tournaments');
		return response.data;
	} catch (error) {
		console.error('Error fetching matches:', error);
		throw error;
	}
};

const getTournamentById = async (id) => {
	const response = await axiosInstance.get(`/tournaments/${id}`);
	return response.data;
};

const getTournamentsWithUpcomingMatches = async (sportType) => {
	try {
		const response = await axiosInstance.get(`/tournaments/with-upcoming-matches?sportType=${sportType}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching tournaments with upcoming matches:', error);
		throw error;
	}
};

const getTournamentsWithLeaderboards = async () => {
    try {
        const response = await axiosInstance.get('/tournaments/with-leaderboard');
        return response.data;
    } catch (error) {
        console.error('Error fetching tournaments with leaderboards:', error);
        throw error;
    }
};

const getStandings = async (tournamentId) => {
    try {
        const response = await axiosInstance.get(`/tournaments/${tournamentId}/standings`);
        return response.data;
    } catch (error) {
        console.error('Error fetching standings:', error);
        throw error;
    }
};

const createTournament = async (data) => {
    const response = await axiosInstance.post('/tournaments', data);
    return response.data;
};

const updateTournament = async (id, data) => {
    const response = await axiosInstance.put(`/tournaments/${id}`, data);
    return response.data;
};

const getTournamentRounds = async (tournamentId) => {
    const response = await axiosInstance.get(`/tournaments/${tournamentId}/rounds`);
    return response.data;
};

const syncTournamentRounds = async (tournamentId) => {
    const response = await axiosInstance.post(`/tournaments/${tournamentId}/rounds/sync`);
    return response.data;
};

const updateTournamentRoundMultiplier = async (tournamentId, roundId, multiplier) => {
    const response = await axiosInstance.put(
        `/tournaments/${tournamentId}/rounds/${roundId}`,
        { multiplier }
    );
    return response.data;
};

export default {
	getAllTournaments,
	getTournamentById,
	getTournamentsWithUpcomingMatches,
	getTournamentsWithLeaderboards,
	getStandings,
	createTournament,
	updateTournament,
	getTournamentRounds,
	syncTournamentRounds,
	updateTournamentRoundMultiplier,
};
